import { render } from "./ReferentialHeader.vue?vue&type=template&id=549c30be&scoped=true"
import script from "./ReferentialHeader.vue?vue&type=script&lang=js"
export * from "./ReferentialHeader.vue?vue&type=script&lang=js"

import "./ReferentialHeader.vue?vue&type=style&index=0&id=549c30be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-549c30be"],['__file',"src/components/generic/ReferentialHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "549c30be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('549c30be', __exports__)) {
    api.reload('549c30be', __exports__)
  }
  
  module.hot.accept("./ReferentialHeader.vue?vue&type=template&id=549c30be&scoped=true", () => {
    api.rerender('549c30be', render)
  })

}


export default __exports__